import { InputAdornment, OutlinedInput } from '@mui/material';
import React, { FormEvent } from 'react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'src/app/rootStore';
import { addNewMessage, toggleAudioVisualizer } from 'src/store/sprouts-agent/sprouts-agent.slice';
import { sproutsAgentSelector } from 'src/store/sprouts-agent/sprouts-agent.selector';
import { useProfile } from 'src/hooks/useProfile';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import {
  fetchAudio,
  fetchAudioRime,
  fetchNextStepData,
  fetchStreamData,
  stopStream,
} from 'src/components/SproutsAgent/utils';
interface TextProps {
  audioRef: any;
  handleTimeUpdateRef: any;
  abortControllerRef: any;
}
const Text: React.FC<TextProps> = ({ abortControllerRef, audioRef, handleTimeUpdateRef }) => {
  const [input, setInput] = React.useState<string>('');
  const { emailId, customerId, clientSecret } = useProfile();
  const { checkpoint, threadId, chatStreaming, welcomeVoice, messages, audioVisualizerOpen } =
    useSelector(sproutsAgentSelector);
  const dispatch = useDispatch<AppDispatch>();
  const handleInput = (value: string) => {
    setInput(value);
  };
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (chatStreaming) return;
    if (!input || input.length === 0) {
      return;
    }
    dispatch(
      addNewMessage({
        content: input,
        role: 'user',
        contentType: 'simple-text',
      }),
    );
    fetchStreamData(
          false,
          dispatch,
          emailId || '',
          customerId,
          threadId,
          audioRef,
          handleTimeUpdateRef,
          abortControllerRef,
          undefined,
          input, 
          clientSecret,
          checkpoint?.length > 0,
        );
    setInput('');
  };
  const switchToAudio = () => {
    stopStream(dispatch);
    dispatch(toggleAudioVisualizer(true));
    !welcomeVoice &&
      fetchAudioRime(
        '"Hello, I’m Paaulaa, your Sprouts agent. How may I help you?"',
        dispatch,
        audioRef,
        handleTimeUpdateRef,
        abortControllerRef,
      );
  };
  const [focused, setFocused] = React.useState(false);
  const suggestions = [
    {
      query: 'Show companies from India.',
      title: 'Companies in India',
    },
    {
      query: 'Show contacts working at Facebook.',
      title: 'Facebook Employees',
    },
    {
      query: 'Show companies having revenue more than 10M.',
      title: 'High Revenue Companies',
    },
    {
      query: 'Show contacts with job title Manager.',
      title: 'Manager Level Contacts',
    },
  ];
  return (
    <div
      className={`text-section ${(messages.length > 0 || audioVisualizerOpen) && 'less-margin'} ${
        focused && 'stick'
      }`}
      onSubmit={(e) => {
        setFocused(false);
        handleSubmit(e);
      }}
    >
      <form className={`text-box ${focused ? 'expanded' : ''}`}>
        <div className={`${messages.length > 0 ? 'change-bg' : 'input-container '}`}>
          <OutlinedInput
            value={input}
            onFocus={() => {
              messages?.length === 0 && setFocused(true);
            }}
            onBlur={() => setTimeout(() => setFocused(false), 100)}
            onChange={(e) => handleInput(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <div className="actions-btns">
                  {chatStreaming ? (
                    <div className="send-icon" onClick={() => stopStream(dispatch)}>
                      <StopIcon />
                    </div>
                  ) : (
                    <div
                      className={`send-icon ${input.length === 0 ? 'disable-btn' : ''}`}
                      onClick={(e) => {
                        setFocused(false);
                        handleSubmit(e);
                      }}
                    >
                      <ArrowRightAltIcon />
                    </div>
                  )}
                  <div className="mic-icon" onClick={switchToAudio}>
                    <MicIcon />
                  </div>
                </div>
              </InputAdornment>
            }
            placeholder="How can I help you today?"
          />
        </div>

        {focused && suggestions.length > 0 && (
          <div className="suggestions-panel">
            {suggestions.map((s, i) => (
              <div
                key={i}
                className="suggestion"
                onMouseDown={() => {
                  handleInput(s.query);
                }}
              >
                {i % 2 === 0 ? <BusinessOutlinedIcon /> : <GroupsOutlinedIcon />}
                {s.title}
              </div>
            ))}
          </div>
        )}
      </form>
    </div>
  );
};

export default Text;
